var App = App || {};

App.Navigation = (function ($) {
    "use strict";

    var $window = $(window),
        $body = $("body"),
        $header = $("header"),

        $navDesktop = $header.find(".navigation.desktop nav.desktop"),
        $navDesktopPrimary = $header.find(".nav.primary"),
        $navDesktopPrimaryLinks = $navDesktop.find(".nav.primary > .nav-item > a"),
        $navDesktopDropdown = $navDesktop.find(".nav-dropdown-menu"),
        $navDesktopDropdownLinks = $navDesktopDropdown.find("a"),
        $navDesktopTopDropDown = $navDesktop.find(".nav-item.dropdown.popular"),
        $searchDropdown = $navDesktop.find(".nav-item.dropdown.search"),

        $navMobile = $header.find(".navigation.mobile nav.primary"),
        $navMobileMenuLinks = $navMobile.find("a.nav-link"),
        $navMobileDropdown = $("section.nav-dropdown.mobile"),
        $mobileMenuToggle = $navMobile.find("a[href='#nav-dropdown-menu']"),

        $navAccordion = $("#nav-accordion"),
        $navAccordionCards = $navAccordion.find(".card-header button"),

        $overlay = $("#overlay"),

        focusList = [],
        focusIndex = 0,

        scrollDistance = 0,

        showDropdownTimer,
        hideDropdownTimer,
        closeDropdownTimer,
        delay,

        // TO DO: check for this to enable/disable menu animation delay
        prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)"),

        // Change the active dropdown menu by hovering over the parent menu item
        toggleMenuOnMouseover = true;

    function init() {

        $(window).on("orientationchange", function () {
            if (navOpen) {
                closeNavDropdownDesktop();
                closeNavDropdownMobile();

                $(".nav-dropdown")
                    .css("display", "none")
                    .removeClass("slideOutRight");
            }
        });

        $(window).on("orientationchange resize", function () {
            setNavDropdownPosition();
        });

        setNavDropdownPosition();

        // Keyboard navigation
        $(window).on("keydown", function (e) {
            if ($body.hasClass("animating")) {
                e.preventDefault();
            }

            if (navOpen && [27, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                e.preventDefault();

                // Escape
                if (e.keyCode === 27) {
                    closeNavDropdownDesktop();
                    return;
                }
            }

            // Escape
            if (e.keyCode === 27) {
                e.preventDefault();
            }
        });

        // Desktop navigation
        $navDesktopPrimaryLinks.on("keydown", function (e) {
            if ($body.hasClass("animating")) {
                return;
            }

            var $parent = $(this).parent("li");

            // Tab
            if (e.keyCode === 9 && !e.shiftKey) {
                if ($parent.next("li").length > 0) {
                    $parent
                        .next("li")
                        .find("> a")
                        .focus();
                } else {
                    closeNavDropdownDesktop();
                }
            }

            // Shift-Tab
            if (e.keyCode === 9 && e.shiftKey) {
                if ($parent.prev("li").length > 0) {
                    $parent
                        .prev("li")
                        .find("> a")
                        .focus();
                } else {
                    closeNavDropdownDesktop();
                }
            }
        });

        $navDesktopPrimaryLinks.on("keydown", function (e) {
            if ($body.hasClass("animating")) {
                return;
            }

            var $parent = $(this).parent("li");

            // Down
            if (navOpen && e.keyCode === 40) {
                e.preventDefault();
                focusList[0].focus();
            }

            // Left
            if (e.keyCode === 37) {
                e.preventDefault();

                $parent
                    .prev("li")
                    .find("> a")
                    .focus();
            }

            // Right
            if (e.keyCode === 39) {
                e.preventDefault();

                $parent
                    .next("li")
                    .find("> a")
                    .focus();
            }
        });

        $navDesktopDropdownLinks.on("keydown", function (e) {
            var $parent = $navDesktop.find(".active").parent("li");

            // Down
            if (e.keyCode === 40) {
                e.preventDefault();

                if (focusIndex !== focusList.length - 1) {
                    focusIndex++;
                }

                focusList[focusIndex].focus();
            }

            // Up
            if (e.keyCode === 38) {
                e.preventDefault();

                if (focusIndex !== 0) {
                    focusIndex--;
                }

                focusList[focusIndex].focus();
            }

            // Left
            if (e.keyCode === 37) {
                e.preventDefault();

                $parent
                    .prev("li")
                    .find("> a")
                    .focus();
            }

            // Right or Tab
            if (e.keyCode === 39 || e.keyCode === 9) {
                e.preventDefault();

                $parent
                    .next("li")
                    .find("> a")
                    .focus();
            }
        });

        $navDesktopPrimaryLinks.on("blur", function () {
            setTimeout(function () {
                // Close dropdown when tabbing out of it
                if ($navDesktop.find("a:focus").length === 0 && $navDesktopDropdown.find("a:focus").length === 0) {
                    if (navOpen && !$body.hasClass("animating")) {
                        closeNavDropdownDesktop();
                    }
                }
            });
        });

        //$navDesktopPrimaryLinks.on("click focus touchstart", function (e) {
        //    e.preventDefault();

        //    if ($body.hasClass("animating")) {
        //        return;
        //    }

        //    var $this = $(this),
        //        menu = e.target.hash;

        //    if (menu) {
        //        openNavDropdownDesktop($this, menu, e);
        //    } else {
        //        if (e.type === "click") {
        //            if (!$(this).hasClass("dropdown-toggle")) {
        //                window.location.href = $this.attr("href");
        //            }
        //        }
        //    }
        //});

        if (toggleMenuOnMouseover) {
            $navDesktopPrimaryLinks.on("mouseover", function (e) {
                var $this = $(this),
                    menu = $this.data("menu");
                   

                if (menu) {
                    closeAllDropdowns();
                        window.clearTimeout(showDropdownTimer);

                        showDropdownTimer = window.setTimeout(function () {
                            openNavDropdownDesktop($this, menu, e);
                        }, 200);

                        window.clearTimeout(hideDropdownTimer);
                
                }
            });

           

            $navDesktopDropdown.on("mouseover", function () {
                window.clearTimeout(showDropdownTimer);
                window.clearTimeout(hideDropdownTimer);
            });

            $navDesktop.on("mouseenter", function () {
                window.clearTimeout(closeDropdownTimer);
            });
            $navDesktopPrimary.add($navDesktopDropdown).on("mouseleave", function () {
                if (navOpen) {
                   
                    window.clearTimeout(showDropdownTimer);
                    window.clearTimeout(hideDropdownTimer);

                    
                    hideDropdownTimer = window.setTimeout(function () {
                        closeNavDropdownDesktop(500); 
                    }, 250); 
                }
            });

           
            $navDesktopTopDropDown.on("mouseover", function () {
                var $this = $(this);

               
                window.clearTimeout(showDropdownTimer);
                window.clearTimeout(hideDropdownTimer);

                if (navOpen) {
                   
                    closeNavDropdownDesktop();
                }
               
                clearTimeout(hideDropdownTimer); 
                showDropdownTimer = setTimeout(() => {
                    $this.addClass("show");
                    $this.find(".dropdown-menu").addClass("show").css({
                        display: "block",
                        position: "absolute",
                        transform: "translate3d(0px, 0px, 0px)", 
                        top: "100%",
                        left: "0",
                        "will-change": "transform",
                    });
                }, 200); 
            });

            $navDesktopTopDropDown.on("mouseleave", function () {
                var $this = $(this);

                clearTimeout(showDropdownTimer); 
                hideDropdownTimer = setTimeout(() => {
                    $this.removeClass("show");
                    $this.find(".dropdown-menu").removeClass("show").css({
                        display: "",
                        position: "",
                        transform: "",
                        top: "",
                        left: "",
                        "will-change": "",
                    });
                }, 750); 
            });

           
            $navDesktopTopDropDown.find(".dropdown-menu").on("mouseover", function () {
                clearTimeout(hideDropdownTimer); // Cancel hide timer
            });

       

           
            $searchDropdown.on("mouseover", function () {
                var $this = $(this);

                
                window.clearTimeout(showDropdownTimer);
                window.clearTimeout(hideDropdownTimer);

                if (navOpen) {
                   
                    closeNavDropdownDesktop();
                }

              
                if ($navDesktopTopDropDown.hasClass("show")) {
                    $navDesktopTopDropDown.removeClass("show");
                    $navDesktopTopDropDown.find(".dropdown-menu").removeClass("show").css({
                        display: "",
                        position: "",
                        transform: "",
                        top: "",
                        left: "",
                        "will-change": "",
                    });
                }

                clearTimeout(hideDropdownTimer); 
                showDropdownTimer = setTimeout(() => {
                    $this.addClass("show");
                    $this.find(".dropdown-menu").addClass("show").css({
                        display: "block",
                        position: "absolute",
                        transform: "translate3d(-315px, -30px, 0px)",
                        top: "0",
                        left: "0",
                        "will-change": "transform",
                    });
                }, 200); 
            });

            $searchDropdown.on("mouseleave", function () {
                var $this = $(this);

                clearTimeout(showDropdownTimer); 
                hideDropdownTimer = setTimeout(() => {
                    $this.removeClass("show");
                    $this.find(".dropdown-menu").removeClass("show").css({
                        display: "",
                        position: "",
                        transform: "",
                        top: "",
                        left: "",
                        "will-change": "",
                    });
                }, 750); 
            });

           
            $searchDropdown.find(".dropdown-menu").on("mouseover", function () {
                clearTimeout(hideDropdownTimer); 
            });

             

        }

        // Mobile navigation
        $mobileMenuToggle.on("click", function () {
            if (!navOpen) {
                scrollDistance = $window.scrollTop();

                $body.css("top", scrollDistance * -1);

                $mobileMenuToggle.attr("aria-expanded", true);
            } else {
                $body
                    .removeClass("nav-open")
                    .css("top", "");

                $window.scrollTop(scrollDistance);

                $mobileMenuToggle.attr("aria-expanded", false);
            }
        });

        $navMobileMenuLinks.on("click", function (e) {
            e.preventDefault();

            if ($body.hasClass("animating")) {
                return;
            }

            if ($(this).attr("href") !== "/") {
                e.preventDefault();
            }

            var $this = $(this),
                $html,
                menu = $(this).attr("href");

            if (menu) {
                if (!$this.hasClass("active")) {
                    openNavDropdownMobile($this, menu);
                } else {
                    closeNavDropdownMobile($this, menu);
                }
            }
        });

        $navAccordionCards.on("click", function (e) {
            if ($(this).attr("aria-expanded") === "true") {
                if ($(this).data("url") !== undefined) {
                    e.preventDefault();

                    window.location.href = $(this).data("url");
                }
            }
        });

        $overlay.on("click touchstart", function (e) {
            if (!$body.hasClass("animating")) {
                closeNavDropdownDesktop();
                closeNavDropdownMobile();
            }
        });
    }

    function openNavDropdownDesktop($this, menu, e) {
        focusList = [];
        focusIndex = 0;

        $body.addClass("animating");

        if (!navOpen) {
            scrollDistance = $(window).scrollTop();
        }

        $.each($navDesktopDropdown, function () {
            if ($(this).attr("id") !== menu) { 
                var $this = $(this),
                    delay = 0;

                $this
                    .removeClass("animate__slideInDown")
                    .addClass("animate__slideOutUp");

                if (navOpen) {
                    delay = 1000;
                }

                setTimeout(function () {
                    $this.hide();
                }, delay);
            } else {
                $this = $(this);

                $this
                    .css("bottom", "")
                    .removeClass("animate__slideOutUp")
                    .addClass("animate__slideInDown")
                    .show();

                setNavDropdownPosition($this);

                $.each($(this).find("a"), function () {
                    focusList.push(this);
                });
            }
        });

        if (!navOpen) {

            $this
                .attr("aria-expanded", true)
                .addClass("active");

            $navDesktopDropdown
                .css("display", "block")
                .removeClass("animate__slideOutUp")
                .addClass("animate__animated animate__slideInDown");

            $overlay
                .css("display", "block")
                .removeClass("animate__fadeOut")
                .addClass("animate__animated animate__fadeIn");
        }
        else {
            $.each($navDesktopPrimaryLinks, function () {
                if (e.type === ("click" || "touchstart")) {
                    if ($this.hasClass("active")) {
                        closeNavDropdownDesktop();
                    }
                }

                if ($(this).hasClass("active")) {
                    $(this)
                        .attr("aria-expanded", false)
                        .removeClass("active")
                        .blur();
                }
            });

            $this
                .attr("aria-expanded", true)
                .addClass("active");
        }

        scrollDistance = $window.scrollTop();

        $body
            .addClass("nav-open")
            .css("top", scrollDistance * -1);

        navOpen = true;

        setTimeout(function () {
            $body.removeClass("animating");
        },100);
    };

    function closeNavDropdownDesktop(delay) {
        if (!delay) {
            delay = 0;
        }

        if (navOpen) {
            $body.addClass("animating");
        }

        closeDropdownTimer = window.setTimeout(function () {
            $navDesktopDropdown
                .css("bottom", "")
                .removeClass("animate__slideInDown")
                .addClass("animate__slideOutUp");

            $overlay
                .removeClass("animate__fadeIn")
                .addClass("animate__fadeOut");

            $.each($navDesktopPrimaryLinks, function () {
                $(this)
                    .attr("aria-expanded", false)
                    .removeClass("active");
            });

            setTimeout(function () {
                $overlay.css("display", "none");

                $navDesktopDropdown
                    .css("display", "none")
                    .removeClass("animate__slideOutUp");

                $body
                    .removeClass("animating nav-open")
                    .css("top", "");

                $window.scrollTop(scrollDistance);
            }, 500);

            navOpen = false;
        }, delay);
    }

   

    function openNavDropdownMobile($this, menu) {
        if (!navOpen) {
            $body.addClass("animating");
        }

        $this
            .addClass("active")
            .empty()
            .append("<i class='far fa-fw fa-2x fa-times'></i>");

        $(".nav-dropdown")
            .removeClass("animate__slideInRight")
            .addClass("animate__slideOutRight");

        if (!$(menu).hasClass("animate__slideInRight")) {
            $(menu)
                .show()
                .removeClass("animate__slideOutRight")
                .addClass("animate__animated animate__slideInRight");

            $overlay
                .show()
                .removeClass("animate__fadeOut")
                .addClass("animate__animated animate__fadeIn");
        }

        $body.addClass("nav-open");

        navOpen = true;

        setTimeout(function () {
            $body.removeClass("animating");
        }, 1000);
    }

    function closeNavDropdownMobile($this, menu) {
        if (navOpen) {
            $body.addClass("animating");
        }

        if (!$this || $this.attr("id") === "overlay") {
            $this = $navMobile.find("a.active");
            menu = $this.attr("href");
        }

        $this
            .removeClass("active")
            .empty()
            .append("<i class='" + $this.data("icon") + "'></i>");

        $(menu)
            .removeClass("animate__slideInRight")
            .addClass("animate__slideOutRight");

        $overlay
            .removeClass("animate__fadeIn")
            .addClass("animate__fadeOut");

        navOpen = false;

        setTimeout(function () {
            $body.removeClass("animating nav-open");
            $overlay.hide();
        }, 1000);
    }

    function setNavDropdownPosition($this) {
        var viewportHeight = Math.round($window.outerHeight()),
            headerHeight = Math.round($header.outerHeight());

        if (!$this) {
            $navDesktopDropdown.each(function () {
                if ($(this).is(":visible")) {
                    $this = $(this);
                } else {
                    return;
                }
            });
        }

        if ($this) {
            var dropdownHeight = $this.outerHeight(),
                dropdownBottom = viewportHeight - (dropdownHeight + headerHeight);

            if (dropdownBottom < 0) {
                dropdownBottom = 0;
            }

            $navDesktopDropdown.css("bottom", dropdownBottom);
        }

        $navDesktopDropdown.css("top", headerHeight);
        $navMobileDropdown.css("top", headerHeight);
    }

    function closeAllDropdowns() {
       
        const dropdowns = [$navDesktopTopDropDown, $searchDropdown];

       
        dropdowns.forEach(($dropdown) => {
            $dropdown.removeClass("show");
            $dropdown.find(".dropdown-menu").removeClass("show").css({
                display: "",
                position: "",
                transform: "",
                top: "",
                left: "",
                "will-change": "",
            });
        });
    }


    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Navigation.init();
});